// extracted by mini-css-extract-plugin
module.exports = {"main":"LinkDialog_main__1tjQI","btnArea":"LinkDialog_btnArea__jqsoT","header":"LinkDialog_header__1gjM0","title":"LinkDialog_title__1u4Zw","okBtn":"LinkDialog_okBtn__1tvsT"};